angular.module('impactx.MenuDirectives').controller('CookieInfoCtrl', [
    '$scope',
    'cookieService',
    'TranslationService',
    CookieInfoCtrl]);

function CookieInfoCtrl($scope, cookieService, TranslationService) {
    var cookieInfoName = "cookieAccept";
    $scope.cookiesAccepted = !!cookieService.getCookie(cookieInfoName);
    $scope.translations = TranslationService;
    this.acceptCookies = function () {
        cookieService.setCookie(cookieInfoName, true, 365 * 10);
        $scope.cookiesAccepted = true;
    };

}